"use strict";
'use strict';

var collapsible = require('./collapsible.cjs');



exports.Content = collapsible.CollapsibleContent;
exports.Context = collapsible.CollapsibleContext;
exports.PropsProvider = collapsible.CollapsiblePropsProvider;
exports.Root = collapsible.CollapsibleRoot;
exports.RootProvider = collapsible.CollapsibleRootProvider;
exports.Trigger = collapsible.CollapsibleTrigger;
